<template>
  <div
    class="mobile-homework-page"
    :style="handlePageStyle"
    :class="{
      'mobile-homework-page-white':
        startAnswer && showQuestionList[activeIndex]?.question_pid,
      'answer-report-page': showAnswerReport,
      'in-mini': isMini,
    }"
  >
    <!-- 头部 -->
    <div
      v-if="showNav"
      class="page-header-wrap revent-selected"
      :style="handleHeaderStyle"
    >
      <!-- app低版本隐藏自己的返回按钮 低于1.14.0版本 -->
      <i
        v-if="!(isHXApp && compareVersion('1.14.0') === -1)"
        @click="handleGoBack"
        class="back-btn"
        :class="
          isCorrected && startAnswer ? 'el-icon-arrow-left' : 'el-icon-close'
        "
        :style="handleTopStyle"
      ></i>
      <span class="page-title" v-if="showAnswerReport">答题报告</span>
      <!-- 答题 -->
      <template v-else-if="startAnswer">
        <!-- 页面标题 -->
        <div class="page-title-wrap" id="intro-step1">
          <button
            class="change-question-btn"
            @click="changeQuestion(activeIndex - 1, activeIndex)"
          >
            <i class="el-icon-arrow-left"></i>
          </button>
          <p class="question-num">
            <span>{{ activeIndex + 1 }}</span>
            <!-- todo：错题解析 -->
            <span> / {{ showQuestionList.length }}</span>
          </p>
          <button
            class="change-question-btn"
            @click="changeQuestion(activeIndex + 1, activeIndex)"
          >
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
        <!-- 操作区 -->
        <div
          v-if="questionInfoList.length"
          class="operate-wrap"
          :style="handleTopStyle"
        >
          <button
            class="mark-btn"
            id="intro-step2"
            @click="handleMarkQuestion()"
          >
            <img
              class="prevent-selected"
              v-if="questionInfo.is_markers === 1"
              src="../../../assets/images/homework/h5-mark-icon.png"
              alt=""
              draggable="false"
              oncontextmenu="return false;"
            />
            <img
              class="prevent-selected"
              v-else
              src="../../../assets/images/homework/h5-un-mark-icon.png"
              alt=""
              draggable="false"
              oncontextmenu="return false;"
            />
          </button>
          <!-- 提交作业之后不展示答题卡入口 -->
          <button
            v-if="showAnswerSheetBtn"
            class="answer-sheet-btn"
            id="intro-step3"
            @click="showAnswerSheet(false)"
          >
            <img
              class="prevent-selected"
              src="../../../assets/images/homework/answer-sheet-icon.png"
              alt=""
              draggable="false"
              oncontextmenu="return false;"
            />
          </button>
        </div>
      </template>
      <span v-else class="header-cont"></span>
    </div>
    <!-- 小程序的头 -->
    <div
      @click="showAnswerSheet(false)"
      class="mini-nav"
      v-if="!showNav && startAnswer"
    >
      <!-- 页面标题 -->
      <div class="question-num">
        <span>{{ activeIndex + 1 }}</span>
        <!-- todo：错题解析 -->
        <span>/{{ showQuestionList.length }}</span>
      </div>
      <button v-if="showAnswerSheetBtn" class="answer-sheet-btn">
        <img
          width="20"
          height="20"
          class="prevent-selected"
          src="../../../assets/images/homework/answer-sheet-icon.png"
          alt=""
          draggable="false"
          oncontextmenu="return false;"
        />
      </button>
    </div>
    <div class="page-cont-wrap" v-if="workInfo?.id">
      <!-- 答题报告 -->
      <template v-if="showAnswerReport">
        <answer-report />
        <div class="answer-report-page"></div>
      </template>
      <!-- 题目区域 -->
      <question-list
        v-else-if="startAnswer && questionInfoList.length"
        :show-intro="showNav"
        ref="questionList"
        @showAnswerSheet="showAnswerSheet"
      />
      <!-- 作业描述 -->
      <homework-desc v-else-if="!startAnswer" :isClockIn="isClockIn" />
    </div>
    <!-- 答题卡 -->
    <answer-sheet
      v-if="startAnswer"
      ref="answerSheet"
      :deviceSpace="deviceSpace"
    />
  </div>
</template>

<script>
import { WORK_STATUS } from "@saas/components/src/constants/question";
import AnswerReport from "@saas/pages/src/homework/components-mobile/AnswerReport.vue";
import AnswerSheet from "@saas/pages/src/homework/components-mobile/AnswerSheet.vue";
import QuestionList from "@saas/pages/src/homework/components-mobile/QuestionList.vue";
import HomeworkDesc from "@saas/pages/src/homework/components/HomeworkDesc.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import { parseUserAgent } from "@saas/components/src";
import { compareVersion, isHXApp, isMini } from "@saas/components";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  data: function () {
    return {
      deviceSpace: {
        top: 0,
        bottom: 0,
      },
      isHXApp: false,
      WORK_STATUS,
      isClockIn: false,
    };
  },
  created() {
    this.isHXApp = isHXApp();
    this.isMini = isMini();

    if (this.isHXApp) {
      const userAgent = parseUserAgent();
      if (userAgent.deviceSpace) {
        let [top, bottom] = userAgent.deviceSpace.split("-");
        this.deviceSpace = {
          top,
          bottom,
        };
        window.deviceSpace = this.deviceSpace;
        console.log(this.deviceSpace, "=====deviceSpace");
      }
    }
    let id = this.$route.params.id;
    let taskId = this.$route.query?.taskid;
    let actId = this.$route.query?.act_id;
    this.setStartAnswer(false);
    if (this.isMini) {
      // 作业详情
      this.apiGetWorkInfo({ id, taskId, actId });
      this.isClockIn = true;
      this.setIsClockIn(true);
    } else if (this.isHXApp) {
      this.isClockIn = false;
      this.setIsClockIn(false);
      jsToFlutter("getToken");
      EventBus.$off("setToken");
      EventBus.$on("setToken", (isLogin) => {
        // 作业详情
        this.apiGetWorkInfo({ id });
      });
    } else {
      this.setIsClockIn(false);
      this.isClockIn = false;
      // 作业详情
      this.apiGetWorkInfo({ id });
    }
  },
  methods: {
    ...mapMutations("defaultHomework", [
      "setStartAnswer",
      "setShowAnswerReport",
      "setShowErrorAnalysis",
      "setActiveIndex",
      "setIsClockIn",
    ]),
    ...mapActions("defaultHomework", [
      "apiGetWorkInfo",
      "apiMarkerQuestion",
      "apiGetWorkInfoInMini",
    ]),
    compareVersion,
    showAnswerSheet(val) {
      this.$refs.answerSheet.openDrawer(val);
    },
    handleMarkQuestion() {
      let { id, subIndex, pidIndex, errorPidIndex, errorSubIndex } =
        this.questionInfo;
      let params = {
        work_id: this.workId,
        question_id: id,
        is_markers: this.questionInfo?.is_markers === 1 ? 2 : 1,
        subIndex,
        pidIndex,
        errorPidIndex,
        errorSubIndex,
      };
      this.apiMarkerQuestion(params);
    },
    changeQuestion(index, oldIndex) {
      if (index < 0 || index > this.showQuestionList.length - 1) {
        return;
      }
      let type = "pre";
      if (index > oldIndex) {
        type = "next";
      }
      if (
        (oldIndex === 0 && type === "pre") ||
        (oldIndex === this.questionList.length - 1 && type === "next")
      ) {
        return;
      }
      this.$refs.questionList.changeQuestion(index, oldIndex);
    },
    goBack() {
      if (this.isHXApp) {
        // app-判断是否有上一级页面，有调用自己的返回，没有调用flutter的返回
        console.log(this.$route.query, "========changeNav");
        if (this.$route.query.fromName) {
          this.$router.back();
        } else {
          jsToFlutter("closePage");
        }
      } else {
        this.$router.back();
      }
    },
    handleGoBack() {
      if (this.startAnswer && this.canSubmit) {
        this.$confirm(`退出后会为您自动保存`, "提示", {
          cancelButtonText: "退出",
          confirmButtonText: "继续作答",
          customClass: "saas-confirm-message",
          confirmButtonClass: "confirm-btn",
          cancelButtonClass: "cancel-btn",
          closeOnClickModal: false,
          showClose: false,
        })
          .then(() => {})
          .catch(() => {
            this.goBack();
          });
      } else {
        if (this.isCorrected && this.startAnswer) {
          this.setShowAnswerReport(true);
          this.setStartAnswer(false);
          this.setShowErrorAnalysis(false);
          this.setActiveIndex(0);
        } else {
          this.goBack();
        }
      }
    },
  },
  computed: {
    ...mapState("defaultHomework", [
      "questionList",
      "startAnswer",
      "activeIndex",
      "workId",
      "questionInfoList",
      "questionIndexArr",
      "showAnswerReport",
      "showErrorAnalysis",
      "isCorrected",
      "workInfo",
    ]),
    ...mapGetters("defaultHomework", [
      "questionInfo",
      "showQuestionList",
      "canSubmit",
      "showAnswerSheetBtn",
    ]),
    handlePageStyle() {
      return {
        paddingTop: `${this.deviceSpace.top}px`,
      };
    },
    showNav() {
      return !this.isMini;
    },
    handleHeaderStyle() {
      return {
        paddingTop: `calc(0.29rem + ${this.deviceSpace.top}px)`,
      };
    },
    handleTopStyle() {
      return {
        // top: `calc(50% + ${this.deviceSpace.top / 2}px)`,
      };
    },
  },
  components: {
    HomeworkDesc,
    QuestionList,
    AnswerSheet,
    AnswerReport,
  },
};
</script>

<style lang="scss" scoped>
.mobile-homework-page {
  //解决 iOS Safari 中 100vh 引发的滚动条问题
  height: 100vh;
  height: 100dvh;
  background: #f7f8fa;
  //头部
  .page-header-wrap {
    background: #f7f8fa;
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    padding: 0.29rem 0.43rem 0.45rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .header-cont {
      display: flex;
      min-height: 0.53rem;
    }
    .back-btn {
      font-size: 0.53rem;
      color: #1d2129;
      font-weight: bold;
      position: absolute;
      left: 0.43rem;
      // top: 50%;
      // transform: translateY(-50%);
    }
    .page-title {
      font-weight: 500;
      font-size: 0.43rem;
      color: #1d2129;
      line-height: 0.59rem;
    }
    .change-question-btn {
      width: 0.53rem;
      height: 0.53rem;
      background: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      i {
        font-size: 0.25rem;
        color: #4e5969;
        font-weight: 900;
        line-height: 1;
      }
    }
    .page-title-wrap {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 0.37rem;
      color: #1d2129;
      line-height: 0.53rem;
      .question-num {
        margin: 0 0.21rem;
      }
    }
    .operate-wrap {
      position: absolute;
      right: 0.43rem;
      // top: 50%;
      // transform: translateY(-50%);
      display: flex;
      align-items: center;
      img {
        width: 0.53rem;
        height: 0.53rem;
      }
      .answer-sheet-btn {
        margin-left: 0.53rem;
      }
    }
  }
  &.in-mini .page-cont-wrap {
    padding-top: 0.375rem;
  }
  .page-cont-wrap {
    padding-top: 1.27rem;
    padding-bottom: 2.4rem;
    background: #f7f8fa;
    height: 100%;
    &.page-cont-wrap-white {
      background: #fff;
    }
  }

  .mini-nav {
    width: 86px;
    height: 37px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background: #ffffff;
    box-shadow: 0px -4px 6px 0px rgba(29, 33, 41, 0.05);
    border-radius: 6px 0px 0px 6px;
    border: 1px solid #e5e6eb;
    position: fixed;
    right: 0;
    top: 0.375rem;
    z-index: 10;
    .question-num {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #1d2129;
      line-height: 20px;
      text-align: left;
      font-style: normal;
    }
  }
}
.mobile-homework-page.mobile-homework-page-white {
  background: #fff;
  .page-header-wrap,
  .page-cont-wrap {
    background: #fff;
  }
}
.answer-report-page.answer-report-page {
  background: linear-gradient(
    180deg,
    rgba(0, 235, 129, 0.1) 0%,
    rgba(34, 91, 228, 0.1) 40%,
    #f7f8fa 100%
  );
  .page-header-wrap {
    background: transparent;
  }
  .page-cont-wrap {
    position: relative;
  }
  .answer-report-page {
    position: absolute;
    top: 0;
    width: 100%;
    height: 5.57rem;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 235, 129, 0.1) 0%,
      rgba(34, 91, 228, 0.1) 40%,
      #f7f8fa 100%
    );
  }
  .answer-report-wrap {
    position: relative;
    z-index: 2;
  }
}
</style>
